import { rand, randNumber, randWord, randRecentDate } from '@ngneat/falso';

import { titleCase } from '@library/common/functions';

import { ShipmentSnapshot } from './shipment-snapshot';

import { Milestones } from '@library/common/models';
import {
   ShipmentTypes, ShipmentModes,
   MockHawb,
   MockBillingParty,
   MockStatus,
   MockReference,
} from '@library/common/models/mock';

export class MockShipmentSnapshot extends ShipmentSnapshot {
   constructor() {
      super();

      this.shipType = rand([ ...ShipmentTypes ]);
      this.mode = this.shipType === 'domestic' ? 'road' : rand([ ...ShipmentModes ]);
      this.hawb = MockHawb();
      this.references = Array.from({ length: randNumber({ max: 20 }) }, _ => new MockReference() );
      this.servicelevel = titleCase( randWord({ length: 2 }).join( ' ' )) as string;
      this.statuses = Array.from({ length: randNumber({ min: 1, max: 5 }) }, _ => new MockStatus() );

      this.milestones = Milestones( this.mode );
      Object.keys( this.milestones ).slice( 0, randNumber({
         min: 1,
         max: Object.keys( this.milestones ).length,
      })).map( key => this.milestones[key] = randRecentDate({ days: 20 }) );

      this.shipper = new MockBillingParty();
      this.consignee = new MockBillingParty();
      this.bill_to = new MockBillingParty();
   }
}
